import { z } from 'zod'

/**
 * Types for iframe postMessage communication (embed/resize/completion).
 * SCORM messages are handled separately in scormWrapper/crossDomain/common.ts
 */

export const EMBED_MESSAGE_TYPES = {
  IFRAME_HEIGHT: 'vedalib-iframe-height',
  COMPLETE: 'complete',
} as const

// ============================================================================
// IFRAME HEIGHT
// ============================================================================

export const iframeHeightMessageSchema = z.object({
  type: z.literal(EMBED_MESSAGE_TYPES.IFRAME_HEIGHT),
  height: z.number(),
  iframeId: z.string().optional(),
})

export type IIframeHeightMessage = z.infer<typeof iframeHeightMessageSchema>

// ============================================================================
// ELEMENT COMPLETION
// ============================================================================

export const elementCompleteMessageSchema = z.object({
  type: z.literal(EMBED_MESSAGE_TYPES.COMPLETE),
  id: z.string(),
})

export type IElementCompleteMessage = z.infer<typeof elementCompleteMessageSchema>

// ============================================================================
// UNION
// ============================================================================

export const embedMessageSchema = z.discriminatedUnion('type', [
  iframeHeightMessageSchema,
  elementCompleteMessageSchema,
])

export type EmbedMessage = z.infer<typeof embedMessageSchema>

// ============================================================================
// TYPE GUARDS
// ============================================================================

export const isIframeHeightMessage = (data: unknown): data is IIframeHeightMessage =>
  iframeHeightMessageSchema.safeParse(data).success

export const isElementCompleteMessage = (data: unknown): data is IElementCompleteMessage =>
  elementCompleteMessageSchema.safeParse(data).success
